/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/prop-types */
import { Menu } from 'antd'
import styled from 'styled-components'
import Link from './Link'

const StyledMenuDropdown = styled(Menu)`
  font-size: var(--app-subheader-fontsize-s2, --typography-size-s2);
`

const MenuDropdownLogic = ({
  Wrapper,
  items = [],
}: {
  Wrapper: any
  items: any[]
}) => {
  const getMenuItem = (item: any) => ({
    key: new Date().getTime(),
    label: <Link {...item} />,
  })

  const menuItems = items.map((item) => getMenuItem(item))
  return <Wrapper items={menuItems} />
}

const MenuDropdown = ({ items }: { items: any[] }) => (
  <MenuDropdownLogic Wrapper={StyledMenuDropdown} items={items} />
)

export default MenuDropdown
